// Mirrors the visibility filter applied by MultiScopePicker before showing a
// store configuration in the scope picker dropdown. The raw
// `useStoreConfigurationsByPartnerId` GraphQL query returns a superset of
// configs (including Caper-only and other partner-not-visible configs). Code
// that derives nav/UI state from "the user's store configs" should filter
// through this helper first so the derivation matches what the user actually
// sees in the scope picker.
export const isStoreConfigVisibleToPartner = (sc: {
  partnerAccessSettings?: { visibleToPartnersOnIpp?: boolean | null } | null
}): boolean => sc.partnerAccessSettings?.visibleToPartnersOnIpp ?? true
